import { Component } from '@angular/core';
import { Dealer, DEALERS, DealerCurrent } from '../data/dealer';
import { Router } from '@angular/router';
import { DealerService } from '../services/dealer.service';
import { FuncsService } from '../services/funcs.service';

@Component({
    selector: 'app-admin-dealer',
    templateUrl: './admin-dealer.component.html',
    styleUrls: ['./admin-dealer.component.css'],
    standalone: false
})

export class AdminDealerComponent {
  public loading = "";
  dealers = DEALERS;
  displayedDealers = this.dealers;
  search = "";

  constructor(
    private dealerService: DealerService,
    private router: Router,
    private funcs: FuncsService
  ) {}

  ngOnInit(): void {
    this.funcs.checkAdmin();
    this.loading = "Loading...";

    this.dealerService.getDealers().subscribe(dealers => {
      this.dealers = dealers;
      this.displayedDealers = this.dealers;
      this.loading = "";
    });
    this.dealers = this.filterDealers();
  }

  ngAfterViewInit(): void {
    document.getElementById("admin-dealer")?.focus();
  }

  displayDealers() {
    this.displayedDealers = this.filterDealers();
  }

  private filterDealers = () => {
    return this.dealers.filter(this.isDealer);
  };

  private isDealer = (d: Dealer) => {
    var ciSearch = this.search.toLowerCase();
    var ciName = d.name.toLowerCase();
    return (d.pa_code.indexOf(ciSearch) > -1 || ciName.indexOf(ciSearch) > -1) || !ciSearch;
  };
  
  fly(d: Dealer) {
    // DealerCurrent.pa_code = d.pa_code;
    // DealerCurrent.name = d.name;
    // DealerCurrent.tech_count = d.tech_count;
    // DealerCurrent.subscribed = d.subscribed;
    // DealerCurrent.active = d.active;

    // // persist data
    // var dealerStore = {
    //   pa_code: DealerCurrent.pa_code,
    //   name: DealerCurrent.name,
    //   tech_count: DealerCurrent.tech_count,
    //   subscribed: DealerCurrent.subscribed,
    //   active: DealerCurrent.active
    // };
    // window.localStorage.setItem("dealer", JSON.stringify(dealerStore));
    this.funcs.setDealer(d);
    this.router.navigateByUrl('/status-enrolled');
  };
}
